import React, {PropsWithChildren} from "react";
import {VisuallyHidden as PatronVisuallyHidden} from "@unibuddy/patron";

export const VisuallyHidden = ({children}: PropsWithChildren) => {
    return <PatronVisuallyHidden>{children}</PatronVisuallyHidden>;
};
